import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchDashboardStats = createAsyncThunk('dashboard/fetchStats', async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
});

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        stats: null,
        status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
        error: null,
        lastUpdated: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardStats.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDashboardStats.fulfilled, (state, action) => {
                state.status = 'success';
                state.stats = action.payload;
                state.lastUpdated = new Date().toISOString();
                state.error = null;
            })
            .addCase(fetchDashboardStats.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'An error occurred';
            });
    },
});

export default dashboardSlice.reducer;
